/**
 * Verifica se o perfil do usuário está completo.
 * Um perfil é considerado completo quando a pessoa tem um fullname real
 * (não o placeholder "Temp" definido pelo backend para novos cadastros).
 *
 * @param {Object} person - Objeto da pessoa (person)
 * @returns {boolean} true se o perfil está completo
 */
export function isProfileComplete(person) {
  if (!person) return false;
  const { fullname } = person;
  return !!fullname && fullname !== 'Temp';
}

/**
 * Sanitiza os dados da pessoa quando o perfil não está completo (fullname === "Temp").
 * Nesse caso, o backend preenche vários campos com valores aleatórios/placeholder.
 * Esta função limpa todos esses campos para que apareçam vazios na UI/formulários.
 *
 * @param {Object} person - Objeto da pessoa (person)
 * @returns {Object} Objeto com campos placeholder limpos
 */
export function sanitizePersonData(person) {
  if (!person) return person;

  // Se o fullname não é "Temp", o perfil foi preenchido pelo usuário — não sanitiza
  if (person.fullname !== 'Temp') return person;

  const sanitized = { ...person };

  // Limpa os campos pessoais que vêm com valores placeholder
  sanitized.fullname = '';
  sanitized.cpf = '';
  sanitized.rg = '';
  sanitized.birthday = '';

  // Limpa os campos de endereço
  if (sanitized.addresses) {
    sanitized.addresses = {
      ...sanitized.addresses,
      zipcode: '',
      street: '',
      street_number: '',
      complement: '',
      neighborhood: '',
      city: '',
      state: '',
    };
  }

  return sanitized;
}

/**
 * Remove o prefixo +55 do número de telefone para exibição no input com máscara.
 * O backend armazena o número completo com +55, mas o input espera apenas DDD + número.
 *
 * @param {string} phoneNumber - Número de telefone (ex: "+5584988170000")
 * @returns {string} Número sem o prefixo +55 (ex: "84988170000")
 */
export function stripCountryCode(phoneNumber) {
  if (!phoneNumber) return '';
  return phoneNumber.replace(/^\+55/, '');
}
